import { type ReactNode } from 'react'
import { clsx } from 'clsx'
import { assignInlineVars } from '@vanilla-extract/dynamic'
import { borderColorVar, divider, dividerWrapper, iconWrapper } from './Divider.css'

type Props = {
  color?: string
  icon?: ReactNode
  className?: string
}

export function Divider({ color, icon, className }: Props) {
  const hr = (
    <hr
      className={clsx(divider, !icon && className)}
      style={{
        ...assignInlineVars({
          [borderColorVar]: color,
        }),
      }}
    />
  )

  if (!icon) return hr

  return (
    <div className={clsx(dividerWrapper, className)}>
      {hr}
      <span className={iconWrapper}>{icon}</span>
    </div>
  )
}
